module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/rack-server/rackback.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/rack-server/rackback.png
// module id = 606
// module chunks = 0